import * as yup from 'yup';

const NAMESPACE = 'ANNOUNCEMENT';

export const ENDPOINT = 'web-apps/dashboard-school/settings';

export const FETCH_ANNOUNCEMENT = `${NAMESPACE}_FETCH_ANNOUNCEMENT`;
